/**
 * Context-aware work order display numbers (client mirror).
 */

export const CONTEXT = {
  CAMO: 'camo',
  MRO: 'mro'
};

function fallbackId(wo) {
  if (wo?._id) return String(wo._id).slice(-6);
  return '';
}

export function getWorkOrderDisplayNumber(wo, context = CONTEXT.CAMO) {
  if (!wo) return '';
  if (context === CONTEXT.MRO) {
    if (wo.mroJobNumber) return String(wo.mroJobNumber).trim();
    if (wo.workOrderNumber) return String(wo.workOrderNumber).trim();
    if (wo.physicalWorkOrderNumber) return String(wo.physicalWorkOrderNumber).trim();
    return fallbackId(wo);
  }
  if (wo.workOrderNumber) return String(wo.workOrderNumber).trim();
  if (wo.mroJobNumber) return String(wo.mroJobNumber).trim();
  if (wo.physicalWorkOrderNumber) return String(wo.physicalWorkOrderNumber).trim();
  return fallbackId(wo);
}

export function getWorkOrderCandidateNumber(wo, context = CONTEXT.CAMO) {
  if (!wo) return '';
  if (context === CONTEXT.MRO) {
    return wo.workOrderNumber ? String(wo.workOrderNumber).trim() : '';
  }
  return wo.mroJobNumber ? String(wo.mroJobNumber).trim() : '';
}

export function getWorkOrderKeyPair(wo, context = CONTEXT.CAMO) {
  return {
    context,
    primary: getWorkOrderDisplayNumber(wo, context),
    candidate: getWorkOrderCandidateNumber(wo, context)
  };
}
